export default __webpack_public_path__ + "static/media/The Shield of Entropy.5aa6d863.jpg";